var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#8962D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 7.21978C16.5914 6.84517 16.4711 6.40767 16.1402 6.16704C15.8093 5.92642 15.3582 5.94829 15.0492 6.21626L8.04918 12.3413C7.77574 12.5819 7.67731 12.9674 7.80582 13.3065C7.93434 13.6456 8.26246 13.8752 8.62613 13.8752H11.675L9.57223 18.7807C9.4109 19.1553 9.53121 19.5928 9.86207 19.8335C10.1929 20.0741 10.6441 20.0522 10.9531 19.7842L17.9531 13.6592C18.2265 13.4186 18.325 13.0331 18.1964 12.694C18.0679 12.3549 17.7425 12.128 17.3761 12.128H14.3273L16.43 7.21978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation);
export default __webpack_public_path__ + "static/media/activation.f4adb92f4439ad3437744f3834fa0d23.svg";
export { ForwardRef as ReactComponent };